import { useFormContext, useWatch } from 'react-hook-form';
import styles from 'styles/pages/mypage/MypageInfoForm.module.scss';
import { useMutation } from 'react-query';
import { postDupCheckPhoneNum } from 'apis/mypage';
import { FormCheckMsgs } from 'types/components/form';
import { useEffect } from 'react';
import LabelInput from 'components/common/forms/LabelInput';
import { UserRoleType } from 'types/apis/auth';
import { MypageInfoFormFields, TMypageInfoForm } from 'types/form/mypage';
import { STYLES_VARIABLES } from 'constants/styleVariables';

type TProps = {
  disabled?: boolean;
  checkAvailability: boolean;
  placeholderText: string;
  phoneNum?: string | null;
  dupCheckPhoneNumMsg: string | null;
  setDupCheckPhoneNumMsg: (msg: string | null) => void;
};

const PhoneNum = ({
  disabled,
  checkAvailability,
  placeholderText,
  phoneNum,
  dupCheckPhoneNumMsg,
  setDupCheckPhoneNumMsg,
}: TProps) => {
  const { formState, control } = useFormContext<TMypageInfoForm>();
  const phoneNumError = formState.errors.phoneNum;

  const phoneNumValue = useWatch({
    name: MypageInfoFormFields.PhoneNum,
    control,
  });

  const { mutate: dupCheckPhoneNumMutation } = useMutation(
    postDupCheckPhoneNum,
    {
      onSuccess: (data) => {
        if (data === null) {
          setDupCheckPhoneNumMsg(FormCheckMsgs.InvalidInputValue);
        }
        if (!data.data) {
          setDupCheckPhoneNumMsg(FormCheckMsgs.AvailablePhoneNum);
        } else {
          setDupCheckPhoneNumMsg(FormCheckMsgs.AlreadyExistPhoneNum);
        }
      },
    }
  );

  const onClickDupCheckPhoneNum = () => {
    if (!phoneNumValue) {
      return;
    }

    if (phoneNumValue.length !== 11 || !phoneNumValue.startsWith('010')) {
      setDupCheckPhoneNumMsg(FormCheckMsgs.InvalidInputValue);
      return;
    }

    if (phoneNumValue === phoneNum) {
      setDupCheckPhoneNumMsg(FormCheckMsgs.AvailablePhoneNum);
    } else {
      dupCheckPhoneNumMutation({
        phoneNum: phoneNumValue,
        userRole: UserRoleType.STUDENT,
      });
    }
  };

  useEffect(() => {
    setDupCheckPhoneNumMsg(null);
  }, [phoneNumValue, phoneNum]);

  return (
    <>
      <LabelInput
        labelText="연락처"
        placeholderText={placeholderText}
        name={MypageInfoFormFields.PhoneNum}
        disabled={disabled}
        checkAvailability={checkAvailability}
        btnText="중복확인"
        onBtnClick={onClickDupCheckPhoneNum}
        inputStyle={
          !checkAvailability
            ? { backgroundColor: STYLES_VARIABLES.GRAY_01 }
            : {}
        }
        rules={
          checkAvailability
            ? {
                pattern: {
                  value: /^010\d{8}$/,
                  message: FormCheckMsgs.InvalidInputValue,
                },
              }
            : {}
        }
      />
      {!phoneNumError && dupCheckPhoneNumMsg === null && (
        <div className={styles.div}></div>
      )}
      {phoneNumError && checkAvailability && (
        <p className="error_text">{phoneNumError?.message}</p>
      )}
      {!phoneNumError && checkAvailability && dupCheckPhoneNumMsg && (
        <p
          className={`error_text ${
            dupCheckPhoneNumMsg === FormCheckMsgs.AvailablePhoneNum
              ? 'purple_text'
              : ''
          }`}
        >
          {dupCheckPhoneNumMsg}
        </p>
      )}
    </>
  );
};

export default PhoneNum;
